import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "bridge-config"
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.extendedModeSwitchWarning'),
      "open": _vm.switchToWizardMode,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.DeviceMonitoring.ok'),
        color: _vm.color,
        emit: 'switchToWizardMode'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.triggerExtendedModeSwitch = true;
        _vm.switchToWizardMode = false;
      },
      "switchToWizardMode": _vm.doChangeExtendedMode
    }
  }), _c(VRow, {
    staticStyle: {
      "flex-wrap": "nowrap",
      "width": "100%"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c(VCol, {
    staticClass: "flex-grow-1 flex-shrink-0"
  }, [_vm.usage === 'state' && (_vm.deviceTypeHealthConfig || _vm.deviceDriverHealthConfig) ? _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('core-button', {
    attrs: {
      "data-cy": "sync_from_devicetype_btn",
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.syncFromDeviceType'),
      "color": _vm.color,
      "disabled": _vm.mode == 'readonly',
      "prepend-icon": "fa-share-all"
    },
    on: {
      "click": _vm.syncFromDeviceType
    }
  }, [!_vm.isDeviceDriverActive ? _c('span', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.syncFromDeviceType')) + "\n          ")]) : _c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.syncFromDeviceDriver')))])])], 1) : _vm._e()]), _c(VCol, {
    staticClass: "flex-grow-0 flex-shrink-1",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "data-cy": "extended_mode_switch",
      "disabled": _vm.mode == 'readonly',
      "hide-details": "",
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.extendedMode')
    },
    model: {
      value: _vm.triggerExtendedModeSwitch,
      callback: function ($$v) {
        _vm.triggerExtendedModeSwitch = $$v;
      },
      expression: "triggerExtendedModeSwitch"
    }
  })], 1)], 1), !_vm.extendedMode ? [_vm.healthMetrics.length === 0 ? _c('core-button', {
    attrs: {
      "data-cy": "add_btn_empty",
      "disabled": _vm.mode == 'readonly',
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.addNew'),
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.addMetric(0);
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.addNew')) + "\n    ")]) : _vm._e(), _vm._l(_vm.healthMetrics, function (metric, i) {
    return _c('core-n20Card', {
      key: `metric_${i}`,
      staticClass: "dt-card-text-01",
      scopedSlots: _vm._u([{
        key: "buttons",
        fn: function () {
          return [_vm.mode !== 'readonly' ? _c('core-button', {
            attrs: {
              "data-cy": `delete_btn_${i}`,
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.delete'),
              "prepend-icon": "fa-trash-alt"
            },
            on: {
              "click": function ($event) {
                return _vm.deleteMetric(i);
              }
            }
          }) : _vm._e(), _vm.mode !== 'readonly' ? _c('core-button', {
            attrs: {
              "data-cy": `add_btn_${i}`,
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.addNew'),
              "prepend-icon": "fa-plus"
            },
            on: {
              "click": function ($event) {
                return _vm.addMetric(i);
              }
            }
          }) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [_c(VRow, {
      attrs: {
        "align": "top"
      }
    }, [_vm.usage === 'state' ? _c(VCol, {
      attrs: {
        "cols": "6",
        "md": "2"
      }
    }, [_c(VSwitch, {
      attrs: {
        "data-cy": `state_health_ignore_switch_${i}`,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.ignore'),
        "inset": ""
      },
      on: {
        "change": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.isIgnored,
        callback: function ($$v) {
          _vm.$set(metric, "isIgnored", $$v);
        },
        expression: "metric.isIgnored"
      }
    })], 1) : _vm._e(), _c(VCol, {
      attrs: {
        "cols": "3",
        "md": "2"
      }
    }, [_c(VSelect, {
      attrs: {
        "data-cy": `select_type_${i}`,
        "disabled": _vm.mode === 'readonly',
        "items": [{
          value: 'warning',
          text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeWarning')
        }, {
          value: 'error',
          text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeError')
        }],
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "label": _vm.$i18n_t('Common.type'),
        "hide-details": ""
      },
      on: {
        "change": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.type,
        callback: function ($$v) {
          _vm.$set(metric, "type", $$v);
        },
        expression: "metric.type"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "3",
        "md": "2"
      }
    }, [_c(VSelect, {
      attrs: {
        "data-cy": `select_category_${i}`,
        "disabled": _vm.mode === 'readonly',
        "items": [{
          value: 'battery',
          text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.battery')
        }, {
          value: 'connectivity',
          text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.connectivity')
        }, {
          value: 'device',
          text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.device')
        }],
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.label'),
        "hide-details": ""
      },
      on: {
        "change": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.category,
        callback: function ($$v) {
          _vm.$set(metric, "category", $$v);
        },
        expression: "metric.category"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "data-cy": `description_${i}`,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.wizardDescriptionField'),
        "rules": _vm.requiredRule,
        "hide-details": "auto",
        "required": ""
      },
      on: {
        "blur": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.description,
        callback: function ($$v) {
          _vm.$set(metric, "description", $$v);
        },
        expression: "metric.description"
      }
    })], 1)], 1), _c(VRow, [_c(VCol, {
      attrs: {
        "cols": "4"
      }
    }, [metric.operator === 'VALUE_OLDER_THAN' ? _c(VTextField, {
      staticClass: "required",
      attrs: {
        "data-cy": `data_state_${i}`,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.dataState'),
        "value": "_raw",
        "disabled": "",
        "readonly": "",
        "hide-details": ""
      }
    }) : _c(VSelect, {
      staticClass: "required",
      attrs: {
        "data-cy": `select_data_state_${i}`,
        "items": _vm.vDeviceHealthStates,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.dataState'),
        "rules": _vm.requiredRule,
        "item-text": "key",
        "item-value": "id",
        "hide-details": "auto"
      },
      on: {
        "blur": function ($event) {
          return _vm.emitSelection();
        }
      },
      scopedSlots: _vm._u([{
        key: "item",
        fn: function (data) {
          return [_c(VListItemContent, [_c(VListItemTitle, {
            domProps: {
              "innerHTML": _vm._s(data.item.key)
            }
          }), _c(VListItemSubtitle, [_vm._v("\n                  " + _vm._s((data.item.properties || {}).unit) + "\n                ")])], 1)];
        }
      }], null, true),
      model: {
        value: metric.wiredState,
        callback: function ($$v) {
          _vm.$set(metric, "wiredState", $$v);
        },
        expression: "metric.wiredState"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "3"
      }
    }, [_c(VSelect, {
      staticClass: "required",
      attrs: {
        "data-cy": `select_operator_${i}`,
        "items": _vm.operatorSelect,
        "label": _vm.$i18n_t('Consumers.Filter.createDialog.operator'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "hide-details": "auto",
        "required": ""
      },
      on: {
        "blur": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.operator,
        callback: function ($$v) {
          _vm.$set(metric, "operator", $$v);
        },
        expression: "metric.operator"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "5"
      }
    }, [metric.operator === 'VALUE_OLDER_THAN' ? _c(VSelect, {
      staticClass: "required",
      attrs: {
        "data-cy": `select_duration_${i}`,
        "items": _vm.availableDurations,
        "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.olderThanDuration'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "hide-details": "",
        "required": ""
      },
      on: {
        "blur": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.value,
        callback: function ($$v) {
          _vm.$set(metric, "value", $$v);
        },
        expression: "metric.value"
      }
    }) : _c(VTextField, {
      staticClass: "required",
      attrs: {
        "data-cy": `states_value_${i}`,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "hide-details": "auto",
        "required": ""
      },
      on: {
        "blur": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.value,
        callback: function ($$v) {
          _vm.$set(metric, "value", $$v);
        },
        expression: "metric.value"
      }
    })], 1)], 1)], 1);
  })] : [_c('p', {
    staticClass: "card-description my-0"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.text')) + "\n    ")]), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VDataTable, {
    attrs: {
      "headers": _vm.virtualDeviceVariableHeaders,
      "footer-props": _vm.virtualDeviceVariableFooterProps,
      "items": _vm.vDeviceHealthStates,
      "single-select": false,
      "item-key": _vm.stateIdentAttr,
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: "item.value.value",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "width": "140px"
          }
        }, [_vm._v(_vm._s(JSON.stringify(item.value.value)))])];
      }
    }, {
      key: "item.milliseconds_ago",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(item.time_ago) + "\n          ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedVirtualDeviceState,
      callback: function ($$v) {
        _vm.selectedVirtualDeviceState = $$v;
      },
      expression: "selectedVirtualDeviceState"
    }
  })], 1), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mt-2 card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.metricDescription'))
    }
  }), _c('p', {
    staticClass: "mt-2 card-description"
  }, [_c('code', {
    staticClass: "code-oneline elevation-0"
  }, [_vm._v("params = {")]), _vm._l(_vm.selectedVirtualDeviceState, function (param, i) {
    return _c('code', {
      key: `param_${i}`,
      staticClass: "code-oneline elevation-0"
    }, [_vm._v("\n    \"" + _vm._s(param.key) + "\" = { \"value\": LAST_VALUE, \"time\": ISO_TIMESTAMP_LAST_UPDATE },\n  ")]);
  }), _c('code', {
    staticClass: "code-oneline elevation-0"
  }, [_vm._v("};")])], 2), _c(VExpansionPanels, {
    staticClass: "my-4 dt-card-text-01",
    attrs: {
      "value": undefined,
      "flat": ""
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.quickReferenceHeader')) + "\n              ")])]), _c(VExpansionPanelContent, [_c('p', {
    staticClass: "mt-0 card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.metricExample'))
    }
  }), _c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("\n                function (params) { if (params['battery_voltage'].value < 2.5) { return \"Battery almost empty\"; }\n                // has not sent a heartbeat within 24 hours if ((new Date() - new Date(params['heartbeat'].time)) >\n                24*3600*1000) { return \"Device seems offline\"; } return null; }\n              ")])], 1)], 1)], 1), _vm.healthMetrics.length === 0 ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.addNew'),
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.addMetric(0);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.addNew')) + "\n        ")]) : _vm._e(), _vm._l(_vm.healthMetrics, function (metric, i) {
    return _c('core-n20Card', {
      key: `metric_${i}`,
      staticClass: "dt-card-text-01",
      scopedSlots: _vm._u([{
        key: "buttons",
        fn: function () {
          return [_vm.mode !== 'readonly' ? _c('core-button', {
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.delete'),
              "prepend-icon": "fa-trash-alt"
            },
            on: {
              "click": function ($event) {
                return _vm.deleteMetric(i);
              }
            }
          }) : _vm._e(), _vm.mode !== 'readonly' ? _c('core-button', {
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.addNew'),
              "prepend-icon": "fa-plus"
            },
            on: {
              "click": function ($event) {
                return _vm.addMetric(i);
              }
            }
          }) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [_c(VRow, {
      attrs: {
        "align": "top"
      }
    }, [_vm.usage === 'state' ? _c(VCol, {
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c(VSwitch, {
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.ignore'),
        "inset": ""
      },
      on: {
        "change": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.isIgnored,
        callback: function ($$v) {
          _vm.$set(metric, "isIgnored", $$v);
        },
        expression: "metric.isIgnored"
      }
    })], 1) : _vm._e(), _c(VCol, {
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c(VSelect, {
      attrs: {
        "disabled": _vm.mode === 'readonly',
        "items": [{
          value: 'warning',
          text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeWarning')
        }, {
          value: 'error',
          text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeError')
        }],
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "label": _vm.$i18n_t('Common.type'),
        "hide-details": ""
      },
      on: {
        "change": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.type,
        callback: function ($$v) {
          _vm.$set(metric, "type", $$v);
        },
        expression: "metric.type"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c(VSelect, {
      attrs: {
        "data-cy": `select_category_${i}`,
        "disabled": _vm.mode === 'readonly',
        "items": [{
          value: 'battery',
          text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.battery')
        }, {
          value: 'connectivity',
          text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.connectivity')
        }, {
          value: 'device',
          text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.device')
        }],
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.label'),
        "hide-details": ""
      },
      on: {
        "change": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.category,
        callback: function ($$v) {
          _vm.$set(metric, "category", $$v);
        },
        expression: "metric.category"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.identifier'),
        "rules": _vm.identifierRules,
        "hide-details": "auto",
        "required": ""
      },
      on: {
        "blur": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.identifier,
        callback: function ($$v) {
          _vm.$set(metric, "identifier", $$v);
        },
        expression: "metric.identifier"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12"
      }
    }, [_c('code', [_vm._v("function (params) {")]), _c('codemirror', {
      ref: "codemirror",
      refInFor: true,
      staticClass: "elevation-3",
      attrs: {
        "options": _vm.cmOptions
      },
      on: {
        "focus": _vm.onCmFocus,
        "change": function ($event) {
          return _vm.emitSelection();
        },
        "blur": function ($event) {
          return _vm.emitSelection();
        }
      },
      model: {
        value: metric.jsTransformer,
        callback: function ($$v) {
          _vm.$set(metric, "jsTransformer", $$v);
        },
        expression: "metric.jsTransformer"
      }
    }), _c('code', [_vm._v("}")])], 1)], 1)], 1);
  })], 2)], 1)]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };